import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { ItemType, useParameters } from '@web/utils/src';
import { AmountPicker } from '@/components/AmountPicker';
import { LoosePicker } from '@/components/LoosePicker';
import { useAppDispatch } from '@/store/hooks';
import { CartDelivery, CartItem } from '@agrantis/cart';
import { updateCartItem } from '@agrantis/cart/actions/cart';
import { getItemType } from '@agrantis/cart/itemType';

interface Props {
  item: CartItem;
  delivery: CartDelivery;
  noSuggestions?: boolean;
}

const QuantityInput = (props: Props) => {
  const { item, delivery, noSuggestions } = props;
  const [initialValue, setInitialValue] = useState<number>(item.amount || 0);
  const [inputValue, setInputValue] = useState<number>(item.amount || 0);
  const { t } = useTranslation();
  const cartKey = useParameters<{ retailerId: string }>().retailerId;

  const dispatch = useAppDispatch();

  const itemType =
    item &&
    getItemType({
      loose: item.itemData.loose!,
      quantity: item.itemData.quantity!,
      unit: item.itemData.unit,
    });

  const setCartItemQuantity = (
    deliveryId: string,
    data: { quantity?: number },
  ) => {
    dispatch(
      updateCartItem({
        cartKey,
        deliveryId,
        itemId: item.itemData.id,
        amount: data.quantity,
      }),
    );
  };

  const handleActualization = () => {
    if (!item) return;
    setCartItemQuantity(delivery.id, { quantity: inputValue });
    setInitialValue(inputValue);
  };

  return (
    <div
      className={clsx(
        itemType !== ItemType.Loose && 'justify-between',
        'flex min-w-[150px] max-w-[175px] relative',
      )}
    >
      {itemType === ItemType.Loose ? (
        <LoosePicker
          cartItem={item}
          noSuggestions
          quantity={item.amount * item.itemData.quantity}
          onAmountChange={({ amount }) => {
            setInputValue(amount ?? 0);
          }}
        />
      ) : (
        <AmountPicker
          cartItem={item}
          quantity={item.amount}
          onAmountChange={({ amount }) => {
            setInputValue(amount ?? 0);
          }}
        />
      )}
      {initialValue !== inputValue && (
        <p
          className="text-primary-green text-2-0 md:text-1-2 leading-1-0 underline cursor-pointer absolute -bottom-2-2 md:-bottom-1-5"
          onClick={handleActualization}
        >
          {t('inventory.update')}
        </p>
      )}
    </div>
  );
};

export default QuantityInput;
